import { track } from '@leagueplatform/analytics';

import { HEALTH_PROGRAM_STATUS } from '#constants/health-program-status.constants.js';

export const useProgramDetailsAnalytics = (programName, programId, status) => ({
  viewProgramDetailsRemoveModal: () =>
    track('journey.screen_loaded.health_campaign_removal', {
      health_campaign_id: programId,
      health_campaign_name: programName,
      health_campaign_type: '',
      health_campaign_status: '',
    }),
  viewProgramDetailsPage: () =>
    track('journey.screen_loaded.health_campaign_detail', {
      health_campaign_id: programId,
      health_campaign_name: programName,
      health_campaign_type: '',
      is_active_health_campaign: status === HEALTH_PROGRAM_STATUS.ACTIVE,
    }),
  leaveProgram: () =>
    track(
      'journey.button_clicked.health_campaign_detail.remove_health_campaign',
      {
        health_campaign_id: programId,
        health_campaign_name: programName,
        health_campaign_type: '',
        health_campaign_status: 'active',
        contentful_id: '',
      },
    ),
  leaveConfirm: () =>
    track(
      'journey.button_clicked.health_campaign_removal_confirmation.confirm_health_campaign_removal',
      {
        health_campaign_id: programId,
        health_campaign_name: programName,
        health_campaign_type: '',
        health_campaign_status: '',
        contentful_id: '',
      },
    ),
  leaveCancel: () =>
    track(
      'journey.button_clicked.health_campaign_removal.cancel_health_campaign_removal',
      {
        health_campaign_id: programId,
        health_campaign_name: programName,
        health_campaign_type: '',
        health_campaign_status: '',
        contentful_id: '',
      },
    ),
  addProgram: () =>
    track(
      'journey.button_clicked.health_campaign_detail.enroll_in_health_campaign',
      {
        health_campaign_id: programId,
        health_campaign_name: programName,
        health_campaign_type: '',
        health_campaign_status: '',
        contentful_id: '',
      },
    ),
});
